import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useUpsellModal } from "../../hooks";
const UpsellTag = (param)=>{
    let { children, wrapperAttributes = {}, ...feature } = param;
    const { modal, tag } = useUpsellModal(feature);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            modal,
            /*#__PURE__*/ _jsx("span", {
                ...wrapperAttributes,
                children: tag
            })
        ]
    });
};
export { UpsellTag };
